import { exec, getApiToken } from '../utils';
import type {
  DetailsResult,
  UpdateParentSkuDetailsExecVariables,
  UpdateParentSkuDetailsExecResponse
} from '@src/types';

export const updateParentSkuDetails = async (args: UpdateParentSkuDetailsExecVariables): Promise<DetailsResult> => {
  const { token, ...updateFields } = args;

  const apiToken = await getApiToken(token);

  const query = `
      mutation updateParentSkuDetails(
        $parentSku: String!
        $partnerCode: String!
        $token: String!
        $productName: String
        $productDescription: String
        $availability: [String]
        $makeAvailabilitiesConsistent: Boolean
        $departments: [String]
        $categories: [String]
        $partnerCategory: String
        $gender: CodeNameInputTypeRestUser
        $msrpPrice: Int
        $taxCode: String
        $brandDisplay: String
        $rubricCode: String
      ) {
        restUser(token: $token) {
          partner(code: $partnerCode) {
            updateParentSkuDetails(
              parentSku: $parentSku
              productName: $productName
              productDescription: $productDescription
              availability: $availability
              makeAvailabilitiesConsistent: $makeAvailabilitiesConsistent
              departments: $departments
              categories: $categories
              partnerCategory: $partnerCategory
              gender: $gender
              msrpPrice: $msrpPrice
              taxCode: $taxCode
              brandDisplay: $brandDisplay
              rubricCode: $rubricCode
            ) {
              productName
              productDescription
              availability
              isInconsistentAvailability
              departments
              categories
              partnerCategory
              gender {
                code
                name
              }
              msrpPrice
              taxCode
              brandDisplay
              rubricCode
              numberOfRecords
              variants {
                colorCode
                colorDisplay
                variantCount
                skus
                sizeDisplays
                partnerImageUrls
                studioImageUrls
                otherVitalElements
              }
            }
          }
        }
      }
    `;

  const variables = {
    ...updateFields,
    token: apiToken,
  };

  const data = await exec<typeof variables, UpdateParentSkuDetailsExecResponse>(
    query,
    { variables }
  );
  return data.restUser.partner.updateParentSkuDetails;
};
